import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationComponent } from '@shared/components/notification/notification.component';
import { NotificationModel } from './notifications.model';

const SNACK_BAR_CLASS = 'app-snack-bar';
const SNACK_BAR_DURATION = 3000;
const ERROR_MESSAGE_OVERRIDES: { [key: string]: string } = {
  TWO_FA_CODE_IS_WRONG: 'The provided code was incorrect',
};

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly _snackBar = inject(MatSnackBar);

  public showSuccessNotification(message: string, duration?: number) {
    return this.showNotification({ type: 'success', message, duration });
  }

  public showErrorNotification(message: string, error?: HttpErrorResponse, duration?: number) {
    return this.showNotification({
      type: 'error',
      message,
      error,
      duration: duration ?? Number.POSITIVE_INFINITY,
    });
  }

  public showInfoNotification(message: string, duration?: number) {
    return this.showNotification({ type: 'info', message, duration });
  }

  public showNotification(notification: NotificationModel) {
    const data: NotificationModel | undefined =
      notification?.type === 'error'
        ? {
            type: notification.type,
            message: getNotificationErrorMessage(notification),
          }
        : notification;

    return this._snackBar.openFromComponent(NotificationComponent, {
      panelClass: [SNACK_BAR_CLASS, notification?.type || 'warn'],
      data,
      duration: notification?.duration ?? SNACK_BAR_DURATION,
    });
  }
}

function getNotificationErrorMessage(model: NotificationModel) {
  const message = (model.error?.status === HttpStatusCode.BadRequest && model.error?.error?.message) || model.message;

  return ERROR_MESSAGE_OVERRIDES[message] ?? message;
}
